import React from 'react';
import { useSelector } from 'react-redux';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { cloneDeep } from 'lodash';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import Select from '../../../common/Select.jsx';
import styles from '../../gen2_widgets/base/CommonSettings.module.scss';

const DATASOURCE_FIELD_SETTINGS = [
      ["colId", "datasource"],
      ["target_colId", "target_datasource"],
]

export const NUMBER_UNIT_OPTIONS = ["hundreds", "thousands", "millions", "billions"];
export const NUMBER_PRECISION_OPTIONS = [0, 1, 2, 3, 4, 5];

function DatasourceSettingsRow({
  d,
  index,
  colWidth,
  showGroupedDatasource,
  hideColorSelection,
  widgetId,
  setting_fields,
  datasources,
  headerNameOpts
}){
  const setAttribute = useSetWidgetAttribute(widgetId);
  const main_value_ds = useSelector(state => state.dashboard.widgets[widgetId].settings?.main_value_ds);
  const updateDatasourceSetting = (key, index, value) => {
      const currentDatasources = cloneDeep(datasources);
      let datasource = {...datasources[index]};
      datasource[key] = value
      currentDatasources[index] = datasource;
      setAttribute('settings.datasources', currentDatasources);
  };

  return (
    <div className={styles['settings-section']}>
        {DATASOURCE_FIELD_SETTINGS.filter((s) => setting_fields.includes(s[0])).map((s) => (
          <label key={s[0]} className={styles['settings-option']}>
            {I18n.t(s[1])}
            <Select
              value={d[s[0]]}
              onChange={(v) => updateDatasourceSetting(s[0], index, v)}
              options={[{value: "", label: I18n.t("select_from_list")}, ...headerNameOpts]}
            />
          </label>
        ))}
        {setting_fields.includes("name_item") ? (
          <label className={styles['settings-option']}>
            {I18n.t("name_item")}
            <input
              type="text"
              className="form-control"
              name="name_item"
              maxLength={70}
              value={d.name_item}
              onChange={(e) => updateDatasourceSetting("name_item", index, e.target.value)}
            />
          </label>
        ) : null}
        {setting_fields.includes("value") ? (
          <label className={styles['settings-option']}>
            {I18n.t("value")}
            <input
              type="text"
              className="form-control"
              name="value"
              value={d.value ?? d.uuid}
              onChange={(e) => updateDatasourceSetting("value", index, e.target.value)}
            />
          </label>
        ) : null}
        {setting_fields.includes("target") ? (
          <label className={styles['settings-option']}>
            {I18n.t("target")}
            <input
              type="text"
              className="form-control"
              name="target"
              value={d.target}
              onChange={(e) => updateDatasourceSetting("target", index, e.target.value)}
            />
          </label>
        ) : null}
        {setting_fields.includes("number_unit") ? (
          <label className={styles['settings-option']}>
            {I18n.t("number_unit")}
            <Select
              value={d.number_unit}
              options={[{value: "", label: I18n.t("number_unit_none")}, ...NUMBER_UNIT_OPTIONS.map((o) => ({value: o, label: I18n.t(`number_unit_${o}`)}))]}
              onChange={(v) => updateDatasourceSetting("number_unit", index, v)}
            />
          </label>
        ) : null}
        {setting_fields.includes("number_precision") ? (
          <label className={styles['settings-option']}>
            {I18n.t("number_precision")}
            <Select
              value={d.number_precision === void 0 ? 2 : d.number_precision}
              options={NUMBER_PRECISION_OPTIONS.map((o) => ({value: o, label: o}))}
              onChange={(v) => updateDatasourceSetting("number_precision", index, v)}
            />
          </label>
        ) : null}
      {hideColorSelection ? null : (
        <label className={styles['settings-option']}>
          {I18n.t("background_color")}
          <ColorPicker 
          value={d.background_color} 
          onChange={(val) => updateDatasourceSetting("background_color", index, val)}
          data-index={index} />
        </label>
      )}
      {setting_fields.includes("main_value_ds") ? (
        <label className={styles['settings-row']}>
          {I18n.t("main_value_ds")} 
          <input className="ml-1" type="radio" name="is_main_value" value={d.colId} checked={d.colId === main_value_ds} onChange={(e) => setAttribute("settings.main_value_ds", d.colId)}>
          </input>
        </label>
      ) : null }
    </div>
  );
}

export default DatasourceSettingsRow;
